<route>
{
  "meta": {
    "permission": [
      "sales.view_order"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-toolbar-title class="font-weight-black">
          {{ $tc('driver', 0) }}
        </v-toolbar-title>
      </v-toolbar>
      <div class="py-2 px-3">
        <assign-suborder
          v-if="drivers.length > 0"
          :items="drivers"
          mode="driver"
        />
        <p
          v-else
          class="text-center py-5 display-1 grey--text font-weight-bold"
        >
          {{ $vuetify.lang.t('$vuetify.noDataText') }}
        </p>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import AssignSuborder from '@/components/delivery/assingDriver.vue'

export default {
  components: {
    AssignSuborder
  },
  data() {
    return {
      drivers: []
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    })
  },
  watch: {
    drivers(val) {
      if (val.length > 0) {
        this.showDrivers = true
      }
    }
  },
  methods: {
    async getDrivers() {
      const params = new URLSearchParams()
      params.append('role', 'Delivery')
      let assigned = await this.$api.sale.availableusers({ opt: { params } })
      this.drivers = assigned.data.results
    }
  },
  mounted() {
    this.getDrivers()
  }
}
</script>
